module.exports = __webpack_public_path__ + "static/hero-cans2-ee14614d082168a6dd9fa8bb65947b59.png";